import { Link } from "react-router-dom";
import { categories } from "@/mocks/leaks";
import { getCategoryCount } from "@/lib/leaks";

export default function TopicSection() {
  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1200px] px-4 md:px-8">
        <div className="max-w-2xl">
          <p className="text-xs font-medium tracking-widest text-secondary-700">TOPICS · 主题分类</p>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            按你关心的话题找爆料
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            五个长期跟踪的栏目，覆盖现场、内幕、热议、风向与生活。你也可以直接进入列表页做关键词筛选。
          </p>
        </div>

        <div className="mt-9 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((cat, index) => (
            <Link
              key={cat.slug}
              to={`/topic/${cat.slug}`}
              className={`group flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300 md:p-6 ${
                index === 0 ? "lg:col-span-2" : ""
              }`}
            >
              <div className="flex items-start justify-between">
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-secondary-100 text-secondary-700">
                  <i className={`${cat.icon} text-xl`} />
                </span>
                <span className="rounded-full bg-accent-100 px-2.5 py-1 text-xs font-medium text-accent-900">
                  {getCategoryCount(cat.slug)} 条
                </span>
              </div>
              <h3 className="mt-5 font-heading text-lg font-bold text-foreground-950 transition-colors group-hover:text-primary-600">
                {cat.name}
              </h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{cat.desc}</p>
              <span className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-primary-600">
                进入栏目
                <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}